import * as React from 'react';

import type { UpdatedByViewModel } from 'ab-viewModels/account/updatedBy';

import { formatDate } from '@acceligentllc/shared/utils/time';
import { getUserName } from '@acceligentllc/shared/utils/user';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

interface OwnProps {
	cancellationReason: string;
	updatedAt: Nullable<Date>;
	updatedBy: UpdatedByViewModel;
}

type Props = OwnProps;

class CanceledRibbon extends React.PureComponent<Props> {
	static defaultProps: Partial<Props> = {
		cancellationReason: '',
		updatedAt: null,
		updatedBy: { fullName: getUserName(null) },
	};

	render() {
		const { updatedAt, cancellationReason, updatedBy } = this.props;

		return (
			<div className="work-order-upsert__canceled-ribbon">
				<div className="work-order-upsert__ribbon-left">
					Canceled
				</div>
				<div className="work-order-upsert__ribbon-right">
					<span>"{cancellationReason}"</span>
					<span>
						<strong>{updatedAt && formatDate(updatedAt, TimeFormat.DAY_WITH_DATE)}</strong> by <strong>{updatedBy.fullName}</strong>
					</span>
				</div>
			</div>
		);
	}
}

export default CanceledRibbon;
